import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/API/api.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CachingService } from 'src/app/services/cache/caching.service';
import { WidgetsService } from 'src/app/services/ui/widgets.service';

@Component({
  selector: 'app-test-drive-form',
  templateUrl: './test-drive-form.component.html',
  styleUrls: ['./test-drive-form.component.scss'],
})
export class TestDriveFormComponent implements OnInit {
  form: FormGroup;
  currentStep: number = 1;
  screenOne: boolean = true;
  screenTwo: boolean = false;
  screenThree: boolean = false;
  iFrame: boolean = true;
  iFrameURL = 'https://www.jeep.com.au/schedule-a-test-drive/thank-you.html';
  isExpanded: boolean = false;
  valueChanged: { [key: string]: boolean } = {};
  modelSelected: any;
  @Input() value: boolean; // Receive the boolean value here

  constructor(
    public fb: FormBuilder,
    public globalService: GlobalService,
    public modalController: ModalController,
    public apiService: ApiService,
    public cachingService: CachingService,
    private widgetService: WidgetsService
  ) {
    this.form = this.fb.group({
      firstName: [
        '',
        [Validators.required, Validators.pattern(/^[a-zA-Z\-]{2,40}$/)],
      ],
      lastName: [
        '',
        [Validators.required, Validators.pattern(/^[a-zA-Z\-]{2,40}$/)],
      ],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern(/^0[23478]\d{8}$|^[23478]\d{8}$/),
        ],
      ],
      // phone: ['', [Validators.required, Validators.pattern(/^\d{4} \d{4}$/)]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/),
        ],
      ],
      checkbox: [true],
    });
  }

  get firstName() {
    return this.form.get('firstName');
  }
  get lastName() {
    return this.form.get('lastName');
  }

  get phone() {
    return this.form.get('phone');
  }

  get email() {
    return this.form.get('email');
  }

  get checkbox() {
    return this.form.get('checkbox');
  }

  close() {
    const result = this.apiService.getResultantVariable(this.value);
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click::TDF::Cust_Details',
      `${'Form_closed'}_${result}`
    );
    this.globalService.dismissModal();
  }

  nextStep() {
    const result = this.apiService.getResultantVariable(this.value);
    if (
      this.currentStep === 1 &&
      this.form.get('firstName').valid &&
      this.form.get('lastName').valid &&
      this.form.get('phone').valid
    ) {
      this.screenOne = false;
      this.screenTwo = true;
      this.currentStep = 2;
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::TDF::Cust_Details',
        'Name_Number'
      );
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::TDF::Cust_Details',
        `${'Name_Number'}_${result}`
      );
    }
  }

  finish() {
    if (this.currentStep === 2 && this.form.get('email').valid) {
      const result = this.apiService.getResultantVariable(this.value);
      // this.screenTwo = false;
      // this.screenThree = true;
      //Make API call.
      //After API response, open iFrame
      this.submitData();
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::TDF::Cust_Details',
        'Form_Filled'
      );
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::TDF::Cust_Details',
        `${'Form_Filled'}_${result}`
      );
    } else {
      //
    }
  }

  async submitData() {
    try {
      this.widgetService.showLoader();
      const customerCode = await this.cachingService.getDataFromLocal('p_cd');
      const pinData = await this.cachingService.getDataFromSession('c_id');
      const modelData = await this.cachingService.getDataFromSession('modelSelected');
      const modelName = modelData?.model_name || '';

      const firstName = this.form.get('firstName').value;
      const lastName = this.form.get('lastName').value;
      const email = this.form.get('email').value;
      const phoneNumber = this.form.get('phone').value;
      const isChecked = this.form.get('checkbox').value;

      const body = {
        first_name: firstName,
        last_name: lastName,
        email: email,
        phone_number: phoneNumber,
        configuration_id: pinData,
        model_name: modelName,
        post_code: customerCode,
        is_consent: isChecked,
      };

      const response = await this.apiService.post('test-drive-leads/create', body);
      if (response['statusCode'] == 201) {
        // Handle the response here if necessary
        // console.log(response);
        // ------> Flood Light Code
        const modelName = this.globalService.model?.model_name;
        this.apiService.logFloodLightEvents(modelName);
        this.screenThree = true;
        this.screenTwo = false;
        this.widgetService.hideLoader();
      }
    } catch (error) {
      this.widgetService.toastWithButtons('Something went wrong!', 'danger');
      this.widgetService.hideLoader();
      console.error('Error submitting data:', error);
      // Handle the error appropriately
    }
  }

  openIframe() {
    this.screenThree = false;
    const url = this.iFrameURL;
    window.open(url, '_blank');
    this.globalService.dismissModal();
  }

  get isFormValid() {
    if (this.currentStep === 1) {
      return (
        this.form.get('firstName').valid &&
        this.form.get('lastName').valid &&
        this.form.get('phone').valid
      );
    } else if (this.currentStep === 2) {
      return this.form.get('email').valid && this.form.get('checkbox').value;
    }
    return false;
  }

  async ngOnInit() {
    this.modelSelected = await this.cachingService.getDataFromSession(
      'modelSelected'
    );
    this.form.get('firstName')?.valueChanges.subscribe((value) => {
      if (this.form.get('firstName')?.valid) {
        this.valueChanged['firstName'] = true;
      }
    });
    this.form.get('lastName')?.valueChanges.subscribe((value) => {
      if (this.form.get('lastName')?.valid) {
        this.valueChanged['lastName'] = true;
      }
    });

    this.form.get('phone')?.valueChanges.subscribe((value) => {
      if (this.form.get('phone')?.valid) {
        this.valueChanged['phone'] = true;
      }
    });

    this.form.get('email')?.valueChanges.subscribe((value) => {
      if (this.form.get('email')?.valid) {
        this.valueChanged['email'] = true;
      }
    });
  }

  onBlur(field: string) {
    if (this.form.get(field)?.valid && this.valueChanged[field]) {
      const value = this.form.get(field)?.value;
      this.onInput(field, value);
      this.valueChanged[field] = false; // reset the flag
    }
  }

  onInput(field: string, event: any) {
    let eventDescription = '';
    const result = this.apiService.getResultantVariable(this.value);
    switch (field) {
      case 'firstName':
        eventDescription = 'First_Name';
        this.apiService.logGAEvent(
          'uaevent',
          'Content',
          'Click::TDF::Cust_Details',
          eventDescription
        );
        this.apiService.logGAEvent(
          'uaevent',
          'Content',
          'Click::TDF::Cust_Details',
          `${eventDescription}_${result}`
        );
        break;
      case 'lastName':
        eventDescription = 'Last_Name';
        this.apiService.logGAEvent(
          'uaevent',
          'Content',
          'Click::TDF::Cust_Details',
          eventDescription
        );
        this.apiService.logGAEvent(
          'uaevent',
          'Content',
          'Click::TDF::Cust_Details',
          `${eventDescription}_${result}`
        );
        break;
      case 'phone':
        eventDescription = 'Mobile_Number';
        this.apiService.logGAEvent(
          'uaevent',
          'Content',
          'Click::TDF::Cust_Details',
          eventDescription
        );
        this.apiService.logGAEvent(
          'uaevent',
          'Content',
          'Click::TDF::Cust_Details',
          `${eventDescription}_${result}`
        );
        break;
      case 'email':
        eventDescription = 'Email_ID';
        this.apiService.logGAEvent(
          'uaevent',
          'Content',
          'Click::TDF::Cust_Details',
          eventDescription
        );
        this.apiService.logGAEvent(
          'uaevent',
          'Content',
          'Click::TDF::Cust_Details',
          `${eventDescription}_${result}`
        );
        break;
    }
  }

  toggleText() {
    const result = this.apiService.getResultantVariable(this.value);
    const descriptionWrap = document.querySelector(
      '.one3d-email-description-wrap'
    );
    descriptionWrap.classList.toggle('expanded');
    this.isExpanded = !this.isExpanded;
    if (this.isExpanded) {
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::TDF::Cust_Details',
        'See_More'
      );
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::TDF::Cust_Details',
        `${'See_More'}_${result}`
      );
    }
    return this.isExpanded ? 'See Less' : 'See More';
  }
}
